<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 企业公告
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            
            <div class="next-box">
                <el-button
                    type="danger"
                    icon="el-icon-delete-solid"
                    @click="delAllSelection"
                    v-if="$store.state.roleid!=5"
                >批量删除</el-button>
                 <el-button
                    type="primary"
                    icon="el-icon-circle-plus"
                    @click="addVisiable= true"
                >添加</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column prop="id" label="ID" width="55" align="center"></el-table-column>
                <el-table-column prop="title" label="公告标题"   align="center"></el-table-column>
                <el-table-column prop="notice" label="企业动态"  align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            @click="handleEdit(scope.$index, scope.row)"
                        >查看详情（编辑）</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="create_time" label="创建时间" width="200px" align="center"></el-table-column>
                <el-table-column label="操作" width="300" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
                        >编辑</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
                            v-if="$store.state.roleid!=5"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
         <!-- 添加弹出框 -->
        <el-dialog title="添加企业公告" :visible.sync="addVisiable" width="1000px">
            <el-form ref="addForm" :rules="rules" :model="addForm" label-width="100px" >
               <el-form-item prop="title" label="公告标题">
                     <el-input v-model="addForm.title" ></el-input>
               </el-form-item>
                <el-form-item label="企业公告" prop="notice">
                   <mavon-editor v-model="addForm.notice" ref="md" @imgAdd="$imgAdd" @change="change" style="min-height: 600px"/>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisiable = false">取 消</el-button>
                <el-button type="primary" @click="addData()">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 编辑弹出框 -->
        <el-dialog title="编辑企业公告" :visible.sync="editVisible" width="1000px">
            <el-form ref="editForm" :rules="rules" :model="editForm" label-width="100px" >
                <el-form-item prop="title" label="公告标题">
                     <el-input v-model="editForm.title" ></el-input>
                </el-form-item>
                <el-form-item label="企业公告" prop="notice">
                   <mavon-editor v-model="editForm.notice" ref="md" @imgAdd="$imgAdd" @change="change" style="min-height: 600px"/>
                </el-form-item>
            </el-form>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit()">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>


import { post } from '../../../api/request';
import { mavonEditor } from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
export default {
    name: 'basetable',
    components: {
        mavonEditor
    },
    data() {
        return {
             content:'',
                html:'',
                configs: {
            },//富文本
            companyid:'',//当前公司id
            //搜索数据
            tableData: [],
            query:{
                notice:'',
                pageIndex: 1,
                pageSize: 8
            },
            pageTotal: 0,
            //添加数据
            addVisiable:false,
            addForm:{
               notice:'',
               title:''
            },
            //编辑数据
            editVisible:false,
            editForm:{},
            //添加数据表单验证
            rules: {
                notice: [
                    { required: true, message: '请输入公告内容', trigger: 'blur' },
                ],
                title: [
                    { required: true, message: '请输入公告标题', trigger: 'blur' },
                ],
               
            },
            //批量删除
            multipleSelection: [],
            delList: [],
            //获取id
            idx: -1,
            id: -1
        };
    },
    created() {
        this.companyid =  sessionStorage.getItem('companyid')
        this.getData()
    },
    activated() {
        this.companyid =  sessionStorage.getItem('companyid')
        this.getData()
    },
    methods: {
        addData(){
            let formdata = new FormData()
            formdata.append('notice',this.addForm.notice)
            formdata.append('title',this.addForm.title)
            formdata.append('label',this.html)
            formdata.append('company_id',this.companyid)
            let url  = 'admin/home/addnotice'
            this.$refs['addForm'].validate((valid) => {
                if (valid) {
                    post(url,formdata).then(res=>{
                        if(res.data.msg =="添加成功"){
                            this.$message.success("添加成功")
                            this.getData()
                            this.$refs['addForm'].resetFields();
                            this.addVisiable = false 
                        }
                        else{
                            this.$messaga.error("添加失败")
                        }          
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            })
        },
         // 将图片上传到服务器，返回地址替换到md中
        $imgAdd(pos, $file){
            var formdata = new FormData();
            formdata.append('file', $file);
            // 这里没有服务器供大家尝试，可将下面上传接口替换为你自己的服务器接口
            post('admin/file/url',formdata).then((res) => {
                this.$refs.md.$img2Url(pos, res.data);
            })
        },
        change(value, render){
            // render 为 markdown 解析后的结果
            this.html = render;
        },
        //重置表单
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        //重置搜索
        resetsearch(){
            this.query.pageIndex = 1
            this.query.notice= '',
            this.getData()
        },
        // 获取后端接口数据
        getData() {
            let formdata = new FormData()
            formdata.append('company_id',this.companyid)
            formdata.append('notice',this.query.notice)
            formdata.append('page',this.query.pageIndex)
            formdata.append('limit',this.query.pageSize)
            post('admin/home/notice',formdata).then(res => {
                if(res.code=200){
                    this.tableData = res.data.data.list;
                    this.pageTotal = res.data.data.num
                    if (!this.tableData.length && this.query.pageIndex > 1) {
                        this.query.pageIndex--;
                        this.getData()
                    }
                }
                else{
                    this.$message.error("暂无数据")
                }
            });
        },
        // 触发搜索按钮
        inputSearch(){
            let formdata = new FormData()
            formdata.append('company_id',this.companyid)
            formdata.append('notice',this.query.notice)
            formdata.append('page',1)
            formdata.append('limit',this.query.pageSize)
            post('admin/home/notice',formdata).then(res => {
                if(res.data.data){
                    this.tableData = res.data.data.list
                    this.pageTotal = res.data.data.num
                }
            });
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    let formdata = new FormData()
                    formdata.append('id',row.id)
                    post('admin/home/deletas',formdata).then(res=>{
                        if(res.data.msg=="删除成功"){
                            this.$message.success('删除成功');
                            this.getData()
                        }
                        else
                            this.message.error('删除失败')
                    })
                })
                .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
            let str = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                str += this.multipleSelection[i].id + ',';
            }
            let formdata = new FormData()
            formdata.append('id',str)
            post('admin/home/alldeles',formdata).then(res=>{
                if(res.data.msg == "删除成功"){
                    this.multipleSelection = [];
                    this.$message.success('删除成功')
                    this.getData()
                }
                else{
                    this.$message.error('删除失败')
                }
            })
        },
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
            this.editForm = Object.assign({}, row);
            this.editVisible = true;
        },
        // 保存编辑
        saveEdit() {
            this.$refs['editForm'].validate((valid) => {
                if (valid) {
                    let formdata = new FormData()
                    formdata.append('id',this.editForm.id)
                    formdata.append('title',this.editForm.title)
                    formdata.append('label',this.html)
                    formdata.append('notice',this.editForm.notice)
                    post('admin/home/updanotice',formdata).then(res=>{
                        if(res.data.msg == "修改成功"){
                            this.getData()
                            this.$message.success('修改成功')
                            this.editVisible = false
                        }
                        else{
                            this.$message.error('修改失败')
                        }
                    
                    })
                }
            })
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>

.next-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.editor-btn{
    margin-top: 20px;
}
</style>
